import { useQuery } from 'react-query'
import { getServiceProviders } from '../../../utils/badaAppointmentApi'

export const useServiceProviders = (
  storeId,
  serviceId,
  includeHidden,
  disabled
) =>
  useQuery(
    ['useServiceProviders', storeId, serviceId, includeHidden],
    () => getServiceProviders(storeId, serviceId, includeHidden),
    { enabled: !!storeId && !disabled }
  )
